import React from "react"
import * as Yup from "yup"
import Icon from "../../Icon/Icon"
import {useModal} from "react-modal-hook"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"
import {JWTProviders} from "../../../resources/orgSettings"
import Button from "../../Button/Button"
import TextField from "../TextField/TextField"

const jwksPathSchema = Yup.string()
	.required("JWKS path is required")
	.matches(/^https:\/\/([A-Za-z0-9\-\.]+)\.auth0\.com\/\.well-known\/jwks\.json$/, "Must be a valid Auth0 JWKS URL")
const customDomainSchema = Yup.string().url("Custom domain must be a valid URL")
const issuerSchema = Yup.string()

export default function Auth0Fields() {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={JWTProviders.Auth0} />
	))

	return (
		<div className="jwt-fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="https://{yourAuth0Domain}/jwks.json"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</>
				}
			/>
			<TextField
				name="customDomain"
				label="Custom Domain"
				placeholder="https://your-custom-domain.com"
				validationSchema={customDomainSchema}
				optional
			/>
			<TextField
				name="issuer"
				label="Issuer"
				placeholder="https://your-domain.auth0.com"
				validationSchema={issuerSchema}
				optional
			/>
		</div>
	)
}
